import { render, staticRenderFns } from "./KernelInputMessages.vue?vue&type=template&id=22d43c81&"
import script from "./KernelInputMessages.vue?vue&type=script&lang=js&"
export * from "./KernelInputMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports